<template>
    <!-- Cabeçalho -->
    <header class="cardapio-digital-cabecalho-header custom-header">
        <div class="cardapio-digital-cabecalho-container">
            <div>
                <i class="cardapio-digital-cabecalho-btn-voltar
                      is-clickable 
                      fas fa-arrow-left"
                @click="voltarListaGrupo()">
            </i> 
            </div>
            <div>
                <p>Cardápio</p>
            </div>
            
            
        </div>
    </header>
</template>

<script>
export default {
    name: 'HearderSimples',
    methods: {
        voltarListaGrupo() {
            this.$router.push({ name: 'Grupos'})
        }
    }
}
</script>

<style scoped>

    .cardapio-digital-cabecalho-header {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 100vw;
        min-height: 2.7rem;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }

    .cardapio-digital-cabecalho-container {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        width: 90vw;
        max-width: 800px;
    }

    .cardapio-digital-cabecalho-btn-voltar {
        position: absolute;
        justify-items: start;
        font-size: 25px;
        margin-left: 10px;
        padding: 0.2rem;
    }

    .cardapio-digital-cabecalho-container p{
        color:#444444;
        font-size: 20px;
        text-align: center;
    }

</style>